<template>
	<div class="painel-visualizacao">
		<botao-voltar
			v-if="rotaAnterior"
			label-voltar="voltar para listagem"
			:nome-rota-anterior="rotaAnterior"
		></botao-voltar>

		<az-container class="az-container-mobile">
			<iframe class="container-iframe" :src="url"> </iframe>
		</az-container>
	</div>
</template>
<script>
import { routesNames } from '@/core/constants'

export default {
	name: 'painel-visualizacao-view',
	data() {
		return {
			rotaAnterior: routesNames.RELATORIO.PAINEL_LISTAGEM,
		}
	},
	computed: {
		url() {
			return this.$route.query.url
		},
	},
	async created() {
		if (!this.url) {
			await this.$router.push({
				name: routesNames.RELATORIO.PAINEL_LISTAGEM,
			})
		}
	},
}
</script>

<style scoped lang="stylus">
.painel-visualizacao
	height 100%

.az-container
	height calc(100% - 63px)
	width calc(100% - 2.5rem)

.container-iframe
	height 100%
	width 100%
	border 0

@media (max-width: 720px)
	.az-container-mobile
		&.az-container
			border-radius 0 !important
			margin 0 !important
			width 100% !important
</style>
